export default __webpack_public_path__ + "96c26f1ce1821188b3b3552a56a7d51b.ttf";